import { useEffect, useState } from 'react';

const footerColumns = [
  {
    title: '页面分区',
    links: [
      { href: '#features', label: '观影特色' },
      { href: '#catalog', label: '精选片单' },
      { href: '#device', label: '多端适配' },
      { href: '#guide', label: '观看指南' },
    ],
  },
  {
    title: '更多信息',
    links: [
      { href: '#ranking', label: '人气推荐' },
      { href: '#faq', label: '常见问题' },
      { href: '#entrance', label: '网址入口' },
      { href: '#top', label: '返回顶部' },
    ],
  },
];

export default function SiteFooter() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <footer className="w-full bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 md:pt-16 pb-8">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="w-full lg:w-[46%]">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-xl">
                <i className="ri-film-line" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">九七电影院</span>
            </div>
            <p className="mt-5 text-background-200/90 text-xs md:text-sm leading-relaxed max-w-md">
              本站是一个围绕在线观影入口做信息整理的单页站点，内容涵盖在线观看、免费观影、高清播放、手机版、
              网页入口与网址等常见搜索方向。所有片单、评分与介绍均为演示内容，用于说明页面信息的组织方式，
              不构成对任何具体作品的评价，也不提供任何下载或账号服务。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              {['在线观看', '免费观影', '高清播放', '手机版', '网页入口', '网址'].map((t) => (
                <span
                  key={t}
                  className="px-3 py-1.5 rounded-full bg-background-50/10 text-background-200 text-[11px] md:text-xs"
                >
                  {t}
                </span>
              ))}
            </div>
          </div>

          <div className="w-full lg:w-[54%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            {footerColumns.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading font-semibold text-sm text-background-50">{col.title}</h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href}
                        className="text-background-200/80 text-xs md:text-sm hover:text-primary-300 transition-colors"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
            <div>
              <h4 className="font-heading font-semibold text-sm text-background-50">浏览建议</h4>
              <ul className="mt-4 flex flex-col gap-2.5 text-background-200/80 text-xs md:text-sm">
                <li className="flex items-start gap-2">
                  <i className="ri-bookmark-line mt-0.5" />
                  优先使用书签访问
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-wifi-line mt-0.5" />
                  高清播放注意网络
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-smartphone-line mt-0.5" />
                  手机版竖屏已适配
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-300/80 text-[11px] md:text-xs text-center sm:text-left">
            © {new Date().getFullYear()} 九七电影院 · 在线观影入口信息整理 · 内容仅供浏览参考
          </p>
          <div className="flex items-center gap-3 text-background-300/80 text-[11px] md:text-xs">
            <a href="#top" className="hover:text-primary-300 transition-colors">
              回到顶部
            </a>
            <span className="w-px h-3 bg-background-50/20" />
            <a href="#faq" className="hover:text-primary-300 transition-colors">
              帮助说明
            </a>
          </div>
        </div>
      </div>

      {showTop && (
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          aria-label="回到页面顶部"
          className="fixed bottom-6 right-5 z-40 w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xl hover:bg-accent-600 transition-colors animate-fade-in"
        >
          <i className="ri-arrow-up-line" />
        </button>
      )}
    </footer>
  );
}